import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'msToTime',
})
export class MsToTimePipe implements PipeTransform {
  transform(value: number): string {
    const hours: number = Math.floor(value / 3600000);
    const minutes: number = Math.floor((value % 3600000) / 60000);

    if (hours <= 0) {
      if (minutes <= 0) {
        return '0m';
      }

      return `${minutes}m`;
    }
    return `${hours}h ${('' + minutes).padStart(2, '0')}m`;
  }
}
